<h2 *ngIf="isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarMultiImagePost.createTitle" | translate }}
</h2>
<h2 *ngIf="!isNewPost" mat-dialog-title>
  {{ "brand.campaign.contentCalendarMultiImagePost.updateTitle" | translate }}
</h2>
<mat-dialog-content>
  <form>
    <div class="section upload-image">
      <p class="section__title">
        {{ "brand.campaign.contentCalendarMultiImagePost.images" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendarMultiImagePost.linkedInUploadMediaTitle'
              | translate
          }}"
        ></app-tooltip>
      </p>
      <ng-container *ngIf="post.images?.length > 0">
        <div class="preview-container">
          <app-carousel-preview
            #carouselPreview
            (itemSelected)="onThumbnailSelected($event)"
            [itemSizePx]="72"
            [numVisibleItems]="5"
          >
            <div
              carouselItem
              *ngFor="let item of post.images"
              [image]="'url(' + item.url + ')'"
              [fileType]="item.fileType"
              [file]="item"
              [id]="item.id"
            ></div>
          </app-carousel-preview>
          <app-file-uploader
            *ngIf="canUploadMoreFiles() && post.images?.length > 0"
            [uploadHtmlTemplate]="uploaderHtmlTemplate"
            [uploadUrl]="uploaderUrl"
            [maxFileSize]="MAX_FILE_SIZE"
            (apiResponse)="handleUploadCarouselResponse($event)"
            (uploadError)="fileUploaderErrorHandler($event)"
            [responseMapper]="fileUploaderResponseMapper"
          />
        </div>
        <app-carousel-edit
          #carouselEdition
          [slides]="post.images"
          [showTitles]="false"
          [showDescriptions]="false"
          [showAltTexts]="false"
          (deleteItem)="onActionDeleteItem($event)"
        />
      </ng-container>
      <app-file-uploader
        *ngIf="canUploadMoreFiles() && !post.images?.length"
        [uploaderTitle]="
          'brand.campaign.contentCalendarCarouselPost.dragAndDropText'
            | translate
        "
        [uploaderSubtitle]="uploaderSubtitle"
        [uploadUrl]="uploaderUrl"
        [maxFileSize]="MAX_FILE_SIZE"
        (fileAddedToQueue)="imageSelected($event)"
        (apiResponse)="handleUploadCarouselResponse($event)"
        (uploadError)="fileUploaderErrorHandler($event)"
        [responseMapper]="fileUploaderResponseMapper"
      />
    </div>
    <app-brand-campaign-content-form-post-suggested-text
      *ngIf="allValidPostTags"
      [platform]="LINKEDIN"
      [text]="post.text"
      [postTags]="allValidPostTags"
      [type]="campaign.type"
      (textChanged)="textChanged($event)"
    >
    </app-brand-campaign-content-form-post-suggested-text>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <app-content-creation-dialog-actions
    [creationMode]="isNewPost"
    [isSaving]="isSaving"
    [isSaveDisabled]="isSaveDisabled"
    (cancel)="onActionCancel()"
    (save)="onActionSave()"
    (preview)="onActionPreview()"
  ></app-content-creation-dialog-actions>
</mat-dialog-actions>
